import { render, staticRenderFns } from "./BLDWine.vue?vue&type=template&id=58aa7830&scoped=true"
import script from "./BLDWine.vue?vue&type=script&lang=js"
export * from "./BLDWine.vue?vue&type=script&lang=js"
import style0 from "./BLDWine.vue?vue&type=style&index=0&id=58aa7830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58aa7830",
  null
  
)

export default component.exports